<template>
<div class="chapter">
<div class="inner_page">
<p class="C153"><a id="page_xiii">Abbreviations</a></p><a id="page_xiii">
<div class="table">
<table cellpadding="0px" cellspacing="0px" class="table1">
<colgroup>
<col width="20%"/>
<col width="80%"/>
</colgroup>
<tbody><tr class="Row_Style5"><td class="Col_Style2">AmCham</td>
<td class="Col_Style4">American Chamber of Commerce in Taipei</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">APEC</td>
<td class="Col_Style4">Asia-Pacific Economic Cooperation</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">APROC</td>
<td class="Col_Style4">Asia-Pacific Regional Operations Center</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">ARATS</td>
<td class="Col_Style4">Association for Relations Across the Taiwan Straits</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">ASE</td>
<td class="Col_Style4">Advanced Semiconductor Engineering</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">ASEAN</td>
<td class="Col_Style4">Association of Southeast Asian Nations</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">ASEAN+3</td>
<td class="Col_Style4">ASEAN plus Three (China, Japan, and South Korea)</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">BOFT</td>
<td class="Col_Style4">Bureau of Foreign Trade</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">CCP</td>
<td class="Col_Style4">Chinese Communist Party</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">CECA</td>
<td class="Col_Style4">Comprehensive Economic Cooperation Agreement</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">CEO</td>
<td class="Col_Style4">chief executive officer</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">CEPA</td>
<td class="Col_Style4">Closer Economic Partnership Arrangement</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">CEPD</td>
<td class="Col_Style4">Council for Economic Planning and Development (renamed National Development Council in 2014)</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">CIER</td>
<td class="Col_Style4">Chung-Hua Institution for Economic Research</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">CNAIC</td>
<td class="Col_Style4">Chinese National Association of Industry and Commerce</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">CNFI</td>
<td class="Col_Style4">Chinese National Federation of Industries</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">CSECC</td>
<td class="Col_Style4">Cross-Strait Economic Cooperation Committee</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">CSR</td>
<td class="Col_Style4">Center for Survey Research, Academia Sinica</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">CSTED</td>
<td class="Col_Style4">Conference on Sustaining Taiwan’s Economic Development</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">DGBAS</td>
<td class="Col_Style4">Directorate General of Budget, Accounting, and Statistics</td>
</tr>
<tr class="Row_Style6"><td class="Col_Style2">DPP</td>
<td class="Col_Style4">Democratic Progressive Party</td>
</tr>
<tr class="Row_Style2"><td class="Col_Style3"><a id="page_xiv">ECFA</a></td>
<td class="Col_Style6">Economic Cooperation Framework Agreement</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">EDAC</td>
<td class="Col_Style6">Economic Development Advisory Conference</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">ESC</td>
<td class="Col_Style6">Election Study Center, National Chengchi University</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">FDI</td>
<td class="Col_Style6">foreign direct investment</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">FNS</td>
<td class="Col_Style6">future national status</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">FSC</td>
<td class="Col_Style6">Financial Supervisory Commission</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">FTA</td>
<td class="Col_Style6">free trade agreement</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">GSMC</td>
<td class="Col_Style6">Grace Semiconductor Manufacturing Corp.</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">GVSRC</td>
<td class="Col_Style6">Global Views Survey Research Center</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">HKSE</td>
<td class="Col_Style6">Hong Kong Stock Exchange</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">IC</td>
<td class="Col_Style6">integrated circuit</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">ICMOEA</td>
<td class="Col_Style6">Investment Commission of the Ministry of Economic Affairs</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">IMF</td>
<td class="Col_Style6">International Monetary Fund</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">INPR</td>
<td class="Col_Style6">Institute for National Policy Research</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">KMT</td>
<td class="Col_Style6">Kuomintang (also known as the Chinese Nationalist Party)</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">MAC</td>
<td class="Col_Style6">Mainland Affairs Council</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">MNC</td>
<td class="Col_Style6">multinational corporation</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">MOEA</td>
<td class="Col_Style6">Ministry of Economic Affairs</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">MOU</td>
<td class="Col_Style6">memorandum of understanding</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">MTA</td>
<td class="Col_Style6">Cross-Strait Merchandise Trade Agreement</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">NAC</td>
<td class="Col_Style6">National Affairs Conference</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">NASME</td>
<td class="Col_Style6">National Association of Small and Medium Enterprises</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">NBSC</td>
<td class="Col_Style6">National Board of Statistics of China</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">NDC</td>
<td class="Col_Style6">National Development Conference</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">NDCL</td>
<td class="Col_Style6">National Development Council (until 2014, known as the Council for Economic Planning and Development)</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">NP</td>
<td class="Col_Style6">New Party</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">NPF</td>
<td class="Col_Style6">National Policy Foundation</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">NSC</td>
<td class="Col_Style6">National Security Council</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">NTAROC</td>
<td class="Col_Style6">National Teachers’ Association, Republic of China</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">NTD</td>
<td class="Col_Style6">new Taiwan dollar</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">NUC</td>
<td class="Col_Style6">National Unification Council</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">NUG</td>
<td class="Col_Style6">National Unification Guidelines</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">PCT</td>
<td class="Col_Style6">Presbyterian Church in Taiwan</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">PFP</td>
<td class="Col_Style6">People First Party</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style3">PRC</td>
<td class="Col_Style6">People’s Republic of China</td>
</tr>
<tr class="Row_Style4"><td class="Col_Style3">PTA</td>
<td class="Col_Style6">preferential trade agreement</td>
</tr>
<tr class="Row_Style7"><td class="Col_Style1"><a id="page_xv">R&amp;D</a></td>
<td class="Col_Style5">research and development</td>
</tr>
<tr class="Row_Style8"><td class="Col_Style1">ROC</td>
<td class="Col_Style5">Republic of China</td>
</tr>
<tr class="Row_Style8"><td class="Col_Style1">ROCCOC</td>
<td class="Col_Style5">General Chamber of Commerce of the Republic of China</td>
</tr>
<tr class="Row_Style8"><td class="Col_Style1">SARS</td>
<td class="Col_Style5">Severe Acute Respiratory Syndrome</td>
</tr>
<tr class="Row_Style8"><td class="Col_Style1">SEF</td>
<td class="Col_Style5">Straits Exchange Foundation</td>
</tr>
<tr class="Row_Style8"><td class="Col_Style1">SME</td>
<td class="Col_Style5">small and medium-size enterprise</td>
</tr>
<tr class="Row_Style8"><td class="Col_Style1">SMIC</td>
<td class="Col_Style5">Semiconductor Manufacturing International Corp.</td>
</tr>
<tr class="Row_Style8"><td class="Col_Style1">STA</td>
<td class="Col_Style5">Cross-Strait Service Trade Agreement</td>
</tr>
<tr class="Row_Style8"><td class="Col_Style1">TAIP</td>
<td class="Col_Style5">Taiwan Independence Party</td>
</tr>
<tr class="Row_Style8"><td class="Col_Style1">TAO</td>
<td class="Col_Style5">Taiwan Affairs Office</td>
</tr>
<tr class="Row_Style8"><td class="Col_Style1">TAUP</td>
<td class="Col_Style5">Taiwan Association of University Professors</td>
</tr>
<tr class="Row_Style8"><td class="Col_Style1">TCTU</td>
<td class="Col_Style5">Taiwan Confederation of Trade Unions</td>
</tr>
<tr class="Row_Style8"><td class="Col_Style1">TEA</td>
<td class="Col_Style5">Taiwan Engineers Association</td>
</tr>
<tr class="Row_Style8"><td class="Col_Style1">TEEMA</td>
<td class="Col_Style5">Taiwan Electrical and Electronic Manufacturers’ Association</td>
</tr>
<tr class="Row_Style8"><td class="Col_Style1">TEPU</td>
<td class="Col_Style5">Taiwan Environmental Protection Union</td>
</tr>
<tr class="Row_Style8"><td class="Col_Style1">TIER</td>
<td class="Col_Style5">Taiwan Institute of Economic Research</td>
</tr>
<tr class="Row_Style8"><td class="Col_Style1">TISR</td>
<td class="Col_Style5">Taiwan Indicator Survey Research</td>
</tr>
<tr class="Row_Style8"><td class="Col_Style1">TSMC</td>
<td class="Col_Style5">Taiwan Semiconductor Manufacturing Co.</td>
</tr>
<tr class="Row_Style8"><td class="Col_Style1">TSU</td>
<td class="Col_Style5">Taiwan Solidarity Union</td>
</tr>
<tr class="Row_Style8"><td class="Col_Style1">TWSE</td>
<td class="Col_Style5">Taiwan Stock Exchange</td>
</tr>
<tr class="Row_Style8"><td class="Col_Style1">UMC</td>
<td class="Col_Style5">United Microelectronics Corp.</td>
</tr>
<tr class="Row_Style8"><td class="Col_Style1">UNCTAD</td>
<td class="Col_Style5">United Nations Conference on Trade and Development</td>
</tr>
<tr class="Row_Style8"><td class="Col_Style1">WHO</td>
<td class="Col_Style5">World Health Organization</td>
</tr>
<tr class="Row_Style9"><td class="Col_Style1">WTO</td>
<td class="Col_Style5">World Trade Organization</td>
</tr>
</tbody></table>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Abbreviations.vue?39c24c24